/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Sol_Operasional_A1tInputs */

const en_mk_sol_operasional_a1t = /** @type {(inputs: Mk_Sol_Operasional_A1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rani — Finance & Ops`)
};

const id_mk_sol_operasional_a1t = /** @type {(inputs: Mk_Sol_Operasional_A1tInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rani — Finance & Ops`)
};

/**
* | output |
* | --- |
* | "Rani — Finance & Ops" |
*
* @param {Mk_Sol_Operasional_A1tInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_sol_operasional_a1t = /** @type {((inputs?: Mk_Sol_Operasional_A1tInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Sol_Operasional_A1tInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_sol_operasional_a1t(inputs)
	return en_mk_sol_operasional_a1t(inputs)
});